import ReportIcon from "@mui/icons-material/Report";
import {Box, Button, Link} from "@mui/material";
import React from "react";
import {useParams} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import * as curriculumListApi from "../../../api/educationApi/curriculumListApi";
import MWCaption from "../../../components/MWCaption";
import MWProgress from "../../../components/MWProgress";
import SubTitle from "../../../components/SubTitle";
import {useGetItemQuery} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";
import {FormContents} from "../../../styledComponents/StyledCreateForm";
import {SubMenuGroup} from "../../../styledComponents/StyledListContainer";

const CurriculumReport = () => {
  const {id} = useParams();
  const tokenState = useRecoilValue(tokenSelector);

  const {data: report, isLoading} = useGetItemQuery<ResponseItem<string>>({
    key: ["CurriculumReport", id],
    api: () => curriculumListApi.getReport({token: tokenState, id: parseInt(id!)}),
  });

  if (isLoading) <MWProgress />;
  return (
    <React.Fragment>
      <SubTitle
        subTitle="교육과정 결과 보고서
"
      >
        <Button variant="contained" size="small" sx={{marginLeft: "18px"}}>
          <Link
            href={`/API/ExportCurriculumReportToWord?token=${tokenState}&id=${parseInt(id!)}`}
            sx={{textDecoration: "none", color: "white"}}
          >
            Word로 저장
          </Link>
        </Button>
      </SubTitle>
      <SubMenuGroup></SubMenuGroup>
      <Box>
        <MWCaption title={"보고서 상세"} color="#01579B" icon={<ReportIcon />} />
        <FormContents container rowSpacing={2} justifyContent="center">
          <div dangerouslySetInnerHTML={{__html: report?.item!}}></div>
        </FormContents>
      </Box>
    </React.Fragment>
  );
};

export default CurriculumReport;
